import { useState } from 'react';
import { Button, Space, Table, Tag } from 'antd';
import { SafetyOutlined } from '@ant-design/icons';
import { useQuery } from '@tanstack/react-query';
import { usersApi } from '../../../api/users';
import type { PanelUser } from '../../../types';
import { UserPermissionsModal } from './UserPermissionsModal';
import { EpostaHucresi, ParolaBaglantisiButonu } from '../../../components/users/ParolaBaglantisi';

export function UsersSection({ firmId }: { firmId: number }) {
  const [permUser, setPermUser] = useState<PanelUser | null>(null);

  const { data: users = [] } = useQuery({
    queryKey: ['firm-users', firmId],
    queryFn: () => usersApi.getAll(firmId),
    enabled: !!firmId,
  });

  const columns = [
    {
      title: 'E-posta',
      dataIndex: 'email',
      key: 'email',
      render: (_: string, u: PanelUser) => <EpostaHucresi user={u} />,
    },
    { title: 'Ad', dataIndex: 'name', key: 'name' },
    {
      title: 'Rol',
      dataIndex: 'firmRoleName',
      key: 'firmRoleName',
      render: (v: string | null) => (v ? <Tag>{v}</Tag> : <Tag color="default">—</Tag>),
    },
    {
      title: 'İşlemler',
      key: 'actions',
      render: (_: unknown, u: PanelUser) => (
        <Space size="small">
          <Button size="small" icon={<SafetyOutlined />} onClick={() => setPermUser(u)}>
            İzinler
          </Button>
          <ParolaBaglantisiButonu user={u} size="small" withLabel />
        </Space>
      ),
    },
  ];

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <Table rowKey="id" size="small" columns={columns} dataSource={users} pagination={false} />
      {permUser && (
        <UserPermissionsModal
          firmId={firmId}
          userId={permUser.id}
          firmRoleId={permUser.firmRoleId ?? null}
          open={!!permUser}
          onClose={() => setPermUser(null)}
        />
      )}
    </Space>
  );
}
